import { Action } from 'redux';
import { put, throttle } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import * as actions from './actions';
import { IWindowState } from './reducer';

function* handleInput(size: Action<IWindowState> & { payload: IWindowState }) {
  yield put(actions.updateSize(size.payload));
}

function* watchUpdateRequests() {
  yield throttle(1000, getType(actions.requestUpdateSize), handleInput);
}

export default function*() {
  yield watchUpdateRequests();
}



// WEBPACK FOOTER //
// ./src/store/modules/window/saga.ts